// A team's schedule: the sheet a supervisor hands out in the morning (the old
// system's Job Scheduler). The team's clock-on card on the first page, then
// the location card of each picking job the team works today, each on its own
// page, so a picker scans one to clock on and one to set the job.

import { pdfDocument, qrCardPage, type QrCard } from './qrCard'
import { locationCardPages, type LocationQrs } from '../pickingJobs/locationQrs'

export function teamSchedulePdf(card: QrCard, jobs: LocationQrs[], printedOn: string): string {
  // A job's own card sets the job alone; its row cards stay on the posts.
  const jobCards = jobs.flatMap((q) => q.cards.filter((c) => c.kind === 'job').map((c) => ({ q, card: c })))
  return pdfDocument([qrCardPage(card, printedOn), ...(jobCards.length ? locationCardPages(jobCards, printedOn, true) : [])])
}

// "Alpha Pickers" on 26 Oct 2026: alpha-pickers-schedule-2026-10-26.pdf
export const schedulePdfName = (teamName: string, day: Date) => {
  const d = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`
  return `${teamName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'team'}-schedule-${d}.pdf`
}
